import { useMemo, type ReactElement } from 'react';
import { flagsmithFeatureFlags } from '@/lib/flagsmith';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import { SettingsPageLayout } from '../SettingsPageLayout';
import { SettingsTabContent } from '../SettingsTabContent';
import type { SingletonTabKey } from '../settingsTabs';
import { PersonalWorkspaceSubTab } from './PersonalWorkspaceSubTab';
import { PersonalNotificationsSubTab } from './PersonalNotificationsSubTab';
import { PersonalIntegrationsSubTab } from './PersonalIntegrationsSubTab';
import { PreferencesSubTab } from '../PreferencesSubTab';

export function PersonalSettingsContent(): ReactElement {
  const { flags } = useFeatureFlags([
    flagsmithFeatureFlags.SLACK_SCAN_LOGS_EVENTS,
  ]);
  const isSlackEnabled =
    flags[flagsmithFeatureFlags.SLACK_SCAN_LOGS_EVENTS] ?? true;
  const hasIntegrations = isSlackEnabled;

  const hiddenTabs = useMemo<SingletonTabKey[]>(() => {
    const hidden: SingletonTabKey[] = [];
    if (!hasIntegrations) {
      hidden.push('integrations');
    }
    return hidden;
  }, [hasIntegrations]);

  return (
    <SettingsPageLayout context="singleton" hiddenTabs={hiddenTabs}>
      <SettingsTabContent
        value="workspace"
        context="singleton"
        hiddenTabs={hiddenTabs}
      >
        <PersonalWorkspaceSubTab />
      </SettingsTabContent>
      <SettingsTabContent
        value="integrations"
        context="singleton"
        hiddenTabs={hiddenTabs}
      >
        <PersonalIntegrationsSubTab />
      </SettingsTabContent>
      <SettingsTabContent
        value="notifications"
        context="singleton"
        hiddenTabs={hiddenTabs}
      >
        <PersonalNotificationsSubTab />
      </SettingsTabContent>
      <SettingsTabContent
        value="preferences"
        context="singleton"
        hiddenTabs={hiddenTabs}
      >
        <PreferencesSubTab />
      </SettingsTabContent>
    </SettingsPageLayout>
  );
}
